export default __webpack_public_path__ + "static/news-hero-5617c5a482558a5ae2b26e2b700f5f2d.jpg";